import request from '../utils/request';

const BASE_URL = '/shopping-cart';

const shoppingCartApi = {
  // 分页查询购物车列表
  pageShoppingCarts(params = {}) {
    const {
      page = 1, 
      pageSize = 10, 
      userId, 
      storeId, 
      goodsId, 
      startTime, 
      endTime, 
      sortField = 'create_time', 
      sortOrder = 'desc'
    } = params;

    return request.post(`${BASE_URL}/page`, {
      page,
      pageSize,
      userId,
      storeId,
      goodsId,
      startTime,
      endTime,
      sortField,
      sortOrder
    });
  },

  // 获取购物车详情
  getShoppingCartDetail(cartId) {
    return request.get(`${BASE_URL}/${cartId}`);
  }
};

export default shoppingCartApi; 